import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InfraEndPointModel } from '../models/infraendpoint.model';
import { InfraService } from './infra.service';

@Injectable()
export class HelpvideosService {
  private languageCode: string;
  private coreAPIUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    
    this.infraService.infraDetails$.subscribe((data: InfraEndPointModel) => {
      this.coreAPIUrl = data.WebEndPoint2 + 'HelpVideo';
    });
  }
  public getAllVideos():Observable<any> {
    
    this.languageCode = localStorage.getItem('lang_code');
    return this.http.get(`${this.coreAPIUrl}/GetAllVideoUrl/${this.languageCode}`);
  }
}
